<template>
  <div class="form-group">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group has-success">
          <v-input type="text" name="name" title="Nom de la structure" v-model="newOffice.name"></v-input>
          <v-input type="text" name="website" title="Site web de la structure"  placeholder="https://monsite.fr" v-model="newOffice.website"></v-input>
          <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true"data-original-title="Lien apparaissant dans la confirmation du paiement en ligne de vos réservations">
              <i class="icon-info"></i>
            </span>
            <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" data-original-title="Lien apparaissant dans vos mails pour les clients">
              <i class="icon-info"></i>
            </span>
          <v-input type="text" name="com_link" title="Lien Secondaire"  placeholder="https://monsite.fr" v-model="newOffice.com_link"></v-input>
          <v-input type="text" name="siret" title="Numéro de siret de la structure" placeholder="14 chiffres uniquement" v-model="newOffice.siret"></v-input>
          <!--<v-input type="tel" name="phone" title="Numéro de téléphone prioritaire *" placeholder="10 chiffres uniquement" v-model="newOffice.phone"></v-input>-->
          <inputTel v-model="newOffice.phone" name="phone" title="Numéro de téléphone prioritaire *" placeholder="Entrez un numéro de téléphone" :required="true"></inputTel>
          <!--<v-input type="tel" name="cellphone" title="Numéro de téléphone secondaire" placeholder="10 chiffres uniquement" v-model="newOffice.cellphone"></v-input>-->
          <inputTel v-model="newOffice.cellphone" name="cellphone" title="Numéro de téléphone secondaire" placeholder="Entrez un numéro de téléphone"></inputTel>
          <v-input type="text" name="adress" title="Adresse de la structure" v-model="newOffice.adress"></v-input>
          <v-input type="text" name="iban" title="Numéro IBAN" placeholder="Exemple : FR0123456789012345678901234" v-model="newOffice.iban"></v-input>
          <div class="form-group" v-if="officeModule">
            <span class="tooltips hidden-xs" data-container="body" data-placement="right" data-html="true" :data-original-title="tooltip">
              <i class="icon-info"></i>
            </span>
            <span class="tooltips visible-xs" data-container="body" data-placement="top" data-html="true" :data-original-title="tooltip">
              <i class="icon-info"></i>
            </span>
            <v-input type="text" name="google_drive_link" title="URL google drive" v-model="newOffice.google_drive_link"></v-input>
          </div>
          <div class="form-group row"> <!-- Send auto email basecamp -->
            <label class="col-md-3 col-form-label">
              <span class="tooltips" data-container="body" data-placement="right" data-html="true" data-original-title="Mail automatique envoyé pour une réservation venant du BaseCamp">
                <i class="icon-info"></i>
              </span>
              Envoi de mail auto basecamp
            </label>
            <div class="col-md-1">
              <input v-model="newOffice.send_auto_email_basecamp" type="checkbox" id="switchSendAutoEmailBasecamp" class="switchBtn"
                     data-on-text="Oui" data-off-text="Non" data-size="mini">
            </div>
          </div>
          <div class="form-group row"> <!-- Send auto email online -->
            <label class="col-md-3 col-form-label">
              <span class="tooltips" data-container="body" data-placement="right" data-html="true" data-original-title="Mail automatique envoyé pour une réservation venant d'une vente en ligne">
                <i class="icon-info"></i>
              </span>
              Envoi de mail auto online
            </label>
            <div class="col-md-1">
              <input v-model="newOffice.send_auto_email_online" type="checkbox" id="switchSendAutoEmailOnline" class="switchBtn"
                     data-on-text="Oui" data-off-text="Non" data-size="mini">
            </div>
          </div>
        </div>
        <div v-show="errors">
          <p v-for="error in errors" class="alert alert-danger">{{ error }}</p>
        </div>
        <div>
          <button type="submit" class="btn green" @click="send">Valider les informations</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfficeGeneralForm',
  props: {
    office: {
      type: Object,
      default: () => ({})
    },
    officeModule: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      newOffice: this.office,
      errors:[]
    }
  },
  mounted () {
    $(".switchBtn").bootstrapSwitch();

    $('#switchSendAutoEmailBasecamp').on('switchChange.bootstrapSwitch', (e, val) => this.newOffice.send_auto_email_basecamp = val)
    $('#switchSendAutoEmailOnline').on('switchChange.bootstrapSwitch', (e, val) => this.newOffice.send_auto_email_online = val)
  },
  methods: {
    async send() {
      this.errors = [];
      await axios.put(`/office/${ this.office.id }`, this.newOffice)
      .then(() => this.$snotify.success('informations générales mises à jour'))
      .catch((error) => {
        Object.keys(error.response.data.errors).forEach(key => {
          this.errors.push(error.response.data.errors[key][0]);
        });
      });
    }
  }
};
</script>

<style lang="css" scoped>
</style>
